import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=2d6cf8ac&scoped=true&"
import script from "./FieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./FieldCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FieldCheckbox.vue?vue&type=style&index=0&id=2d6cf8ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cf8ac",
  null
  
)

export default component.exports